// extracted by mini-css-extract-plugin
module.exports = {"container":"_3P-rDcSAwpkgutQvZmTd-k","content":"_1VfTXsd95oQX0-rO-OdLH7","logo":"_1_HEvY0ZO9lZzkENFVwy62","containerIcon":"_2XDX6tO4YfDxWJFpFvacGi"};